import React, { RefObject, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { Amplify } from 'aws-amplify';
import { Provider } from 'react-redux';
import Router from 'router';
import { ToastProvider } from 'react-toast-notifications';
import Toast from 'components/Toast';
import { config } from 'constants/amplify';
import store from 'store';
import smoothscroll from 'smoothscroll-polyfill';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import i18n from 'i18next';
import { Toaster } from 'react-hot-toast';
import { GoogleOAuthProvider } from '@react-oauth/google';

import './i18next';
import { theme } from './theme';
import { remoteConfig } from './utils';

import './App.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
// import { translation } from './configs/translation';
import { translation2 } from 'configs/translation2';

declare global {
  interface Window {
    ReactToastProviderRef: RefObject<unknown>;
  }
}

Amplify.configure(config);

window.ReactToastProviderRef = React.createRef();

function App() {
  useEffect(() => {
    document.title = 'Gumb – Web-App';
    smoothscroll.polyfill();

    (async () => {
      try {
        await fetchAndActivate(remoteConfig);
        const values = getValue(remoteConfig, 'translations').asString();
        const parsed = JSON.parse(values);
        Object.keys(parsed).forEach((lang) => {
          i18n.addResourceBundle(lang, 'translation', parsed[lang], true, true);
        });
      } catch (e) {
        // const parsed = translation;
        const parsed = translation2;
        console.log('parsed', parsed);
        Object.keys(parsed).forEach((lang) => {
          i18n.addResourceBundle(lang, 'translation', parsed[lang], true, true);
        });
      }
    })();
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Toaster />
        <ToastProvider
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          components={{ Toast }}
          placement="top-center"
          ref={window.ReactToastProviderRef}
          autoDismissTimeout={6000}
        >
          <GoogleOAuthProvider clientId="634800902990-5rmde934lu1levk1pfojobifchdin8c3.apps.googleusercontent.com">
            <div className="App">
              <Router />
            </div>
          </GoogleOAuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
